// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2oBJO","footer":"ChangeClinic_footer__178H8"};